var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconArrowThickCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm6.64 12.85-6.29 6.29a.51.51 0 0 1-.71 0l-6.28-6.29a.5.5 0 0 1 .35-.85H9.5a.25.25 0 0 0 .25-.25V5.5a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 .5.5v6.25a.25.25 0 0 0 .25.25h3.78a.5.5 0 0 1 .36.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconArrowThickCircleDown);
export default __webpack_public_path__ + "static/media/streamline-icon-arrow-thick-circle-down.8c15a6fe.svg";
export { ForwardRef as ReactComponent };